export default __webpack_public_path__ + "static/media/financeDashboard.5b7fb5b1.png";